<template>
    <grid
        :isAutoHeight="true"
        :row-data="rowData"
        :is-search="false"
        :column-defs="columnDefs"
        grid-theme="ag-theme-alpine-compact"
        :isAutoWidth="true"
        class="table-header-highlight"
    >
    </grid>
</template>

<script>
import grid from '../../../generic/grid/grid.vue';
import AdminLogBodyCellRenderer from './admin-log-body-cell-renderer.vue';

export default {
    components: { grid, adminLogBodyCellRenderer: AdminLogBodyCellRenderer },
    name: 'DamageClaimsLogsTable',
    data() {
        return {
            values: [],
        };
    },
    props: {
        rowData: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        columnDefs() {
            return [
                {
                    field: 'date',
                    headerName: 'Date',
                    type: 'dateTimeColumn',
                    minWidth: 140,
                    sortable: false,
                },
                {
                    field: 'operation',
                    headerName: 'Operation',
                    minWidth: 180,
                    sortable: false,
                },
                {
                    field: 'subject',
                    headerName: 'Subject',
                    minWidth: 170,
                    sortable: false,
                },
                {
                    field: 'body',
                    headerName: 'Body',
                    minWidth: 170,
                    autoHeight: true,
                    autoWidthExclude: true,
                    cellRenderer: 'adminLogBodyCellRenderer',
                    sortable: false,
                },
            ];
        },
    },
};
</script>